import React from "react";

import { FolderOpen } from "../Icons/FolderOpen";

/**
 * Function to render a component when there is no content.
 *
 * @return {JSX.Element} The rendered component for no content.
 */
const SelectNoContent = () => {
  return (
    <div className="SelectNoContent_Wrapper flex h-[160px] flex-col items-center justify-center">
      <div className="grid gap-2">
        <div className="grid h-[50px] w-[50px] place-items-center rounded-full bg-lightblue text-primary">
          <FolderOpen />
        </div>
        <span className="text-[14px] font-semibold leading-[normal] text-txtColor">
          No Data
        </span>
      </div>
    </div>
  );
};

export default SelectNoContent;
